// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-sequence-container {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  background: #111827;
  padding: 3px;
  border-radius: 16px;

  width: 100%;
  font-family: Arial, sans-serif;
}

.sequence-item {
  background: #1f2937;
  border: 1px solid #374151;

  border-radius: 14px;

  padding: 10px 12px;

  cursor: pointer;

  transition:
    transform 0.15s ease,
    background 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  color: #d1d5db;
}

.sequence-item:hover {
  background: #243041;
  border-color: #60a5fa;

}

.sequence-item.active {
  background: #2563eb;
  border-color: #93c5fd;
  color: white;

  box-shadow:
    0 0 0 1px rgba(255,255,255,0.08),
    0 8px 20px rgba(37, 99, 235, 0.35);
}

.sequence-title {
  font-size: 13px;
  font-weight: 600;

  margin-bottom: 8px;
}

.sequence-meta {
  display: flex;
  gap: 10px;

  font-size: 10px;

  opacity: 0.85;
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/sequences/selectsequence/selectsequence.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;;EAEnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;;EAEzB,mBAAmB;;EAEnB,kBAAkB;;EAElB,eAAe;;EAEf;;;;wBAIsB;;EAEtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;;AAEvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;;EAEZ;;sCAEoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;;EAEhB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;;EAET,eAAe;;EAEf,aAAa;AACf","sourcesContent":[".select-sequence-container {\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  background: #111827;\n  padding: 3px;\n  border-radius: 16px;\n\n  width: 100%;\n  font-family: Arial, sans-serif;\n}\n\n.sequence-item {\n  background: #1f2937;\n  border: 1px solid #374151;\n\n  border-radius: 14px;\n\n  padding: 10px 12px;\n\n  cursor: pointer;\n\n  transition:\n    transform 0.15s ease,\n    background 0.2s ease,\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n\n  color: #d1d5db;\n}\n\n.sequence-item:hover {\n  background: #243041;\n  border-color: #60a5fa;\n\n}\n\n.sequence-item.active {\n  background: #2563eb;\n  border-color: #93c5fd;\n  color: white;\n\n  box-shadow:\n    0 0 0 1px rgba(255,255,255,0.08),\n    0 8px 20px rgba(37, 99, 235, 0.35);\n}\n\n.sequence-title {\n  font-size: 13px;\n  font-weight: 600;\n\n  margin-bottom: 8px;\n}\n\n.sequence-meta {\n  display: flex;\n  gap: 10px;\n\n  font-size: 10px;\n\n  opacity: 0.85;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
